<template>
<transition v-on:enter="enter($event)">
<div 
    class="uploadFilLoading" 
    v-show="judge" 
    :style="{ 
        'z-index': modaldata.Zindex, 
    }" 
    @click="stopDocument($event);"
>

    <transition name="slide-fade">
    <div 
        :class="{
            'uploadFilLoading-body' : uploadType == 0,
            'uploadFilLoadingOne-body' : uploadType == 1,
        }" 
        v-show="judgeBody"
    >
    <div>
        <div 
            v-if="cancelUpload"
            class="closeUpload" 
            @click="closeloadbox()"
        >
           放弃上传
        </div>

        <div 
            class="loadingBox"
            v-if="uploadType == 0"
        >
            <span 
                class="loadingLine"
                :style="{ 
                    'width': loadingData.lodaTime + '%', 
                }" 
            ></span>
        </div>
        <div 
            class="loadingMsg"
            v-if="uploadType == 0"
        >
           <span style="margin-right: 10px;">{{uploadText}}</span>
           <font>{{loadingData.lodaTime + '%'}}</font>
        </div>

        <div 
            class="loadicon el-icon-loading"
            v-if="uploadType == 1"
        >
        </div>
        <div 
            class="loadmsg"
            v-if="uploadType == 1"
        >
            {{uploadText}}
        </div>
        <div 
            class="loadclose"
            @click="closeModal()"
            v-if="uploadType == 1"
        >
            取消上传
        </div>

    </div>
  </div>
  </transition>

</div>
</transition>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import Velocity from 'velocity-animate'
import modal    from '../mixins/modal'
import Analysis from '../mixins/analysis/materialBu'


export default {
  mixins: [modal, Analysis],
  data() {
    return {
      modalName   : 'uploadFilLoading',
      judgeBody   : false,
      loadingData : {
          thisTime : 0,
          lodaTime : 0,
          timeSet  : null, 
      },
      cancelUpload : true,
      uploadText   : '上传视频中',
      uploadType   : 0,
    };
  },
  watch : {
    'boxData' : function(val, oldval){ // 判断打开关闭
        if (this.judge ) { // 打开的操作
            this.loadingData.thisTime = 0;
            this.loadingData.lodaTime = 0;
            this.loadingFS(4);
            if(this.modaldata.data && this.modaldata.data.Ntype){
                switch(this.modaldata.data.Ntype){
                    case 'imagePic':       // 背景
                    case 'imagePicTwo':    // 道具
                        this.cancelUpload = false;
                        this.uploadText = '图片正在上传中...';
                        this.uploadType = 1;
                        break;
                    default : 
                        this.uploadText = '上传视频中';
                        this.uploadType = 0;
                        this.cancelUpload = true;
                }
            }else{
                this.uploadText = '上传视频中';
                this.uploadType = 0;
                this.cancelUpload = true;
            }
        }
    },
  }, 
  mounted () {
    this.$bus.on('uploadResourceLoading_vue', data => {
        clearInterval(this.loadingData.timeSet);
        if(data.schedule == 1){
            this.loadingData.thisTime = 1;
            this.loadingData.lodaTime = 100;

            let timeoutid = setTimeout(() => {
                this.closeModal();
                clearTimeout(timeoutid);
            }, 1000);
        }else{
            this.loadingData.thisTime = data.schedule * 100;
            let prenext = this.loadingData.thisTime - this.loadingData.lodaTime;
            if(prenext < 30){

                this.loadingFS(2);

            }else if(prenext < 20){

                this.loadingFS(3);

            }else if(prenext < 10 || prenext <= 0){

                this.loadingFS(4);

            }else{

                this.loadingFS(1);

            }
        }
    })
    
  },
  methods: {
    enter: function (el, index) { // 打开动画
      Velocity(el, { }, {});
      Velocity(el, { }, { duration:  300, complete: ()=>{
        this.judgeBody = true;
      },});
    },
    loadingFS(data){
        switch(data){
            case 1:
                this.loadingData.timeSet = setInterval(() => {
                    if(
                        this.loadingData.lodaTime < this.loadingData.thisTime &&
                        this.loadingData.lodaTime < 90
                    ){
                        this.loadingData.lodaTime++;
                    }else{
                        this.loadingFS(4);
                    }
                }, 200);
                break;
            case 2:
                this.loadingData.timeSet  = setInterval(() => {
                    if(
                        this.loadingData.lodaTime < this.loadingData.thisTime &&
                        this.loadingData.lodaTime < 90
                    ){
                        
                        this.loadingData.lodaTime++;
                    }else{
                        this.loadingFS(4);
                    }
                }, 1000);
                break;
            case 3:
                this.loadingData.timeSet  = setInterval(() => {
                    if(
                        this.loadingData.lodaTime < this.loadingData.thisTime &&
                        this.loadingData.lodaTime < 90
                    ){

                        this.loadingData.lodaTime++;
                    }else{
                        this.loadingFS(4);
                    }
                }, 2000);
                break;
            case 4:
                clearInterval(this.loadingData.timeSet );
                this.loadingData.timeSet  = setInterval(() => {
                    if(this.loadingData.lodaTime < 90){
                        this.loadingData.lodaTime++;
                    }else{
                        clearInterval(this.loadingData.timeSet );
                    }
                }, 5000);
                break;
        }
    },
    closeloadbox(){
        this.materialPushAnalysis({type: 'videoGiveup'});
        this.loadingData.thisTime = 0;
        this.loadingData.lodaTime = 0;
        this.closeModal();
    },
  },
  components: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .uploadFilLoading{
    .uploadFilLoadingOne-body,
    .uploadFilLoading-body{
        width: 100%;
        height: 100%;
        background: rgba(256,256,256, 0.8);
        overflow: hidden;
        >div{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 430px;
            height: 150px;
            border-radius: 5px;
            font-size: 14px;
        }
    }

    .uploadFilLoading-body{
        >div{
            color: #fff;
            background: rgba(0, 0, 0, 0.7);

            .closeUpload{
                position: absolute;
                top: 10px;
                right: 10px;
                text-decoration: underline;
                color: #dadada;
                cursor: pointer;
                transition: all 0.1s;

                &:hover{
                    color: #fff;
                }
            }

            .loadingBox{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;  
                width: 300px;
                height: 8px;
                background: rgba(256,256,256, 0.5);
                border-radius: 5px;

                .loadingLine{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 0;
                    height: 8px; 
                    background: #fff;
                    border-radius: 5px;
                    transition: all 0.3s;

                    &:before{
                        content:'';
                        position: absolute;
                        top: -4px;
                        right: -12px;
                        width: 16px;
                        height: 16px;
                        background: #fff;
                        border-radius: 100%;
                    }
                }
            }
            .loadingMsg{
                position: absolute;
                left: 0;
                bottom: 30px;
                width: 100%;
            }
        }
    }

    .uploadFilLoadingOne-body{
        background: rgba(0,0,0,0.8);

        >div{
            width: 350px;
            height: 113px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000;
            background: rgba(256,256,256, 0.8);

            .loadicon{
                width: 25px;
                height: 25px;
                font-size: 25px;
                color: #409eff;
            }
            .loadmsg{
                color: #409eff;
                padding: 0 15px;
            }
            .loadclose{
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }    
    
  }
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  width: 0;
  height: 0;
  opacity: 0;
  border-radius: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/modal/uploadFilLoading.vue